/*
 * @author YangLiQiChun
 * @date 2023/5/10
 * @time 17:33
 * @desc:
 */

import { axios } from "@/api/request";

export function login(parameter) {
  return axios({
    method: "post",
    url: "elfcloud/api/user/login",
    data: parameter,
  });
}

export function register(parameter) {
  return axios({
    method: "post",
    url: "elfcloud/api/user/register",
    data: parameter,
  });
}
// 微信公众号支付接口调用
export function wxOfficialAccountLogin(parameter) {
  return axios({
    method: "post",
    url: "elfcloud/api/user/wxOfficialAccountLogin",
    data: parameter,
  });
}


export function getUserInfoByActivity(phone) {
  return axios({
    method: "get",
    url: "elfcloud/api/user/getUserInfoByActivity?mobilePhone=" + phone,
  });
}

// 修改用户渠道以及多预装组ID
export function changeUserChannelAndPreGroup(data) {
  return axios({
    method: "post",
    url: "elfcloud/api/user/changeUserChannelAndPreGroup",
    data :data
  });
}

// 获取用户信息
export function getUserInfo (parameter) {
  return axios({
    method: "get",
    url: "/elfcloud/api/user/getUserInfo",
    params: parameter
  });
}
